module.exports = __webpack_public_path__ + "media/misc/new_window_sprite-75d925be.png";